import React from 'react';
import './Hero.css';

export default function Hero() {
  return (
    <section className="hero landing__column fade-up" aria-label="Introduction">
      <div className="hero__inner">
        <p className="hero__label" aria-hidden="true">MySecureRoom</p>
        <h1 className="hero__title">
          You spent years<br />
          figuring out what<br />
          matters to you.
        </h1>
        <p className="hero__subtitle">
          This is where that work lives.
        </p>
        <p className="hero__lede">
          Values cards. A life wheel. Goals with nested projects.
          A morning check-in drawn from your own priorities.
          All private. All connected. All on your terms.
        </p>
      </div>
    </section>
  );
}
